import React, { ReactNode, useEffect } from 'react';
import i18next from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getBillingInfo } from '../../store/BillingInfo/actions/getBillingInfo';
import { addNotification } from '../../store/EventData/actions/eventData';
import { EVENTS_SUCCESS } from '../../constants/events';
import {
    IUseUserFixedNotificationsFlowExports,
    useUserFixedNotificationsFlow,
} from '../../../hooks/useUserFixedNotificationsFlow';
import { UserFixedNotificationsFlow } from '../../../constants/UserFixedNotificationsFlow';
import { selectEmail } from '../../store/Email/reducer';
import { selectBillingInfo } from '../../store/BillingInfo/reducer';
import { selectUserInfo, selectUserNotifications } from '../../store/User/reducer';
import { Notifications } from '../../../models/Notifications';
import { FlowPatternOption } from '../../../constants/FlowPatternsType';

export const UserFixedNotifications = () => {
    const user = useSelector(selectUserInfo);
    const notifications: Notifications | null = useSelector(selectUserNotifications);
    const billingData = useSelector(selectBillingInfo);
    const emailUpdated = useSelector(selectEmail);
    const dispatch = useDispatch();

    const { userFixedNotifications }: IUseUserFixedNotificationsFlowExports = useUserFixedNotificationsFlow({
        user,
        billingData,
        notifications,
    });

    useEffect(() => {
        dispatch(getBillingInfo());
    }, []);

    useEffect(() => {
        if (emailUpdated.email && emailUpdated.email.resend) {
            dispatch(
                addNotification({
                    detail: {
                        content: i18next.t('default._notifications.email_sended_successfully'),
                    },
                    type: EVENTS_SUCCESS,
                })
            );
        }
    }, [emailUpdated]);

    return (
        <>
            {userFixedNotifications?.map((option: FlowPatternOption<UserFixedNotificationsFlow, ReactNode>) => (
                <React.Fragment key={option.flow}>{option.action()}</React.Fragment>
            ))}
        </>
    );
};
